const authscreenConstants = {
  width: 428,
  height: 927,
};

export default authscreenConstants;
